export default {
  title: 'Why Ostado?',
  list: [
    {
      title: 'Tutors quality takes priority in Ostado',
      img: require('@images/start-teaching/landing/advantages/ostado-tutor-signup-why1.gif')
    },
    {
      title: '+7 years of local expertise, serving over 200k students',
      img: require('@images/start-teaching/landing/advantages//ostado-tutor-signup-why2.gif')
    },
    {
      title: 'Aligning tutoring opportunities with student demand',
      img: require('@images/start-teaching/landing/advantages//ostado-tutor-signup-why3.gif')
    },
    {
      title: 'Improvement opportunities available for online tutor jobs',
      img: require('@images/start-teaching/landing/advantages//ostado-tutor-signup-why4.gif')
    }
  ]
}
